// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDC_tvTDLiLtpXea0xtcTcfn5LTExBQvxA",
  authDomain: "kryptofighters-413c9.firebaseapp.com",
  projectId: "kryptofighters-413c9",
  storageBucket: "kryptofighters-413c9.appspot.com",
  messagingSenderId: "695873010443",
  appId: "1:695873010443:web:9d40fd3d3ace6f4af9800e",
  measurementId: "G-BK0T7M25SQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);

export  { analytics, db };